import React, { useState, useEffect } from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { useImmer } from "use-immer"
import Axios from "axios"

// My Pages
import { Header, Icon, Popup, NotFound } from "./components"
import { Home, Movie, Tv, All, Categories, Genre, SignleActor } from "./pages"
import { FooterSection } from "./sections"
import { API_URL, API_KEY, IMAGE_BASE_URL, POSTER_SIZE } from "./helpers/config"
import { Link } from "react-router-dom"
const NoImage = "https://i.ibb.co/bmkvfbv/No-image.jpg"

function App() {
  const [searchToggle, setSearchToggle] = useState(false)
  const [searchBy, setSearchBy] = useState("movie")
  const [state, setState] = useImmer({
    searchTerm: "",
    results: [],
    show: "neither",
    requestCount: 0,
  })

  useEffect(() => {
    document.addEventListener("keyup", escKeyPressHandler)
    return () => document.removeEventListener("keyup", escKeyPressHandler)
  }, [])

  useEffect(() => {
    if (state.searchTerm.trim()) {
      setState((draft) => {
        draft.show = "loading"
      })
      const delay = setTimeout(() => {
        setState((draft) => {
          draft.requestCount++
        })
      }, 700)
      return () => clearTimeout(delay)
    } else {
      setState((draft) => {
        draft.show = "neither"
      })
    }
    // eslint-disable-next-line
  }, [state.searchTerm])

  useEffect(() => {
    if (state.requestCount && state.searchTerm) {
      // Now here we send axios request
      const ourRequest = Axios.CancelToken.source()
      async function fetchResult() {
        const response = await Axios.get(
          `${API_URL}search/${searchBy}?api_key=${API_KEY}&language=en-US&query=${state.searchTerm}&page=1&include_adult=false`,
          { cancelToken: ourRequest.token }
        )
        setState((draft) => {
          draft.results = response.data.results
          draft.show = "results"
        })
      }
      fetchResult()
      return () => {
        ourRequest.cancel()
      }
    }
    // eslint-disable-next-line
  }, [state.requestCount, searchBy])

  function escKeyPressHandler(e) {
    if (e.keyCode === 27) {
      setSearchToggle(false)
    }
    // eslint-disable-next-line
  }

  function handleSearch(e) {
    const value = e.target.value
    setState((draft) => {
      draft.searchTerm = value
    })
  }

  function closeSearch() {
    setState((draft) => {
      draft.searchTerm = ""
    })
    setState((draft) => {
      draft.results = []
    })
    setSearchBy("movie")
    setSearchToggle(false)
  }

  return (
    <Router>
      {!searchToggle && (
        <Header>
          <Header.Wrapper>
            <Link to="/">
              <Header.Logo />
            </Link>
            <Header.SearchContainer>
              <Header.Nav>
                <Header.NavLink to="/popular-movies" icon="ph-film-strip">
                  Movies
                </Header.NavLink>
                <Header.NavLink to="/tv-shows" icon="ph-television">
                  Tv-Shows
                </Header.NavLink>
                <Header.NavLink to="/categories" icon="ph-list-dashes">
                  Category
                </Header.NavLink>
                <Icon name="ph-magnifying-glass-bold" onClick={() => setSearchToggle(true)} />
              </Header.Nav>
            </Header.SearchContainer>
          </Header.Wrapper>
        </Header>
      )}
      {searchToggle && (
        <Popup>
          <Popup.Header>
            <Popup.Select value={searchBy} onChange={(e) => setSearchBy(e.target.value)}>
              <option value="movie">Movie</option>
              <option value="tv">Tv Show</option>
            </Popup.Select>
            <Popup.Input onChange={handleSearch} value={state.searchTerm} />
            <Icon name="ph-x-circle" onClick={() => setSearchToggle(false)} />
          </Popup.Header>
          <Popup.Body
            prev={Boolean(state.results.length)}
            title={state.show === "results" ? true : false}
            isLoading={state.show === "loading" ? true : false}
          >
            {state.results &&
              state.results.map((movie) => {
                return (
                  <Link key={movie.id} onClick={closeSearch} to={`/${searchBy}/${movie.id}`}>
                    <Popup.MovieCard>
                      <Popup.Thumb rate={movie.vote_average}>
                        <Popup.Rating rate={movie.vote_average} />
                        <Popup.Image
                          path={
                            movie.poster_path
                              ? `${IMAGE_BASE_URL}${POSTER_SIZE}${movie.poster_path}`
                              : NoImage
                          }
                        />
                      </Popup.Thumb>
                      <Popup.Info>
                        <Popup.Name>{movie.title}</Popup.Name>
                        <Popup.Date>{movie.release_date}</Popup.Date>
                        <Popup.Name>{movie.name}</Popup.Name>
                        <Popup.Date>{movie.first_air_date}</Popup.Date>
                      </Popup.Info>
                    </Popup.MovieCard>
                  </Link>
                )
              })}
          </Popup.Body>
        </Popup>
      )}
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>

        <Route path="/movie/:movieId">
          <Movie />
        </Route>
        <Route path="/tv/:tvId">
          <Tv />
        </Route>

        <Route path="/popular-movies">
          <All />
        </Route>

        <Route path="/tv-shows">
          <All />
        </Route>
        <Route path="/top-rated-movies">
          <All />
        </Route>

        <Route path="/categories">
          <Categories />
        </Route>

        <Route path="/genre/:id/movie">
          <Genre />
        </Route>
        <Route path="/actor/:id">
          <SignleActor />
        </Route>

        <Route component={NotFound} />
      </Switch>

      <FooterSection />
    </Router>
  )
}

export default App
